module.exports = __webpack_public_path__ + "static/media/cordLengthIcon.32d19a16.svg";